const getRecommendedProducts = (placements) =>
  new Promise((resolve, reject) => {
    const templateName =
      document.querySelector(".nosto_page_type")?.textContent || null;
    window.nostojs((api) => {
      const session = api.defaultSession();
      let res;

      switch (templateName) {
        case "front": {
          res = session.viewFrontPage();
          break;
        }
        case "product": {
          const productId =
            document.querySelector(".product_id")?.textContent || null;
          res = productId
            ? session.viewProduct(productId)
            : session.viewOther();
          break;
        }
        case "category": {
          const collectionHandle =
            document.querySelector(".category_string")?.textContent || null;
          res = collectionHandle
            ? session.viewCategory(`/${collectionHandle}`)
            : session.viewOther();
          break;
        }
        case "notfound": {
          res = session.viewNotFound();
          break;
        }
        case "cart": {
          res = session.viewCart();
          break;
        }
        default: {
          res = session.viewOther();
        }
      }

      res
        .setPlacements(placements ?? api.placements.getPlacements())
        .update()
        .then(async (response) => {
          if (Object.keys(response.recommendations).length === 0) {
            console.warn("No recommendations found. Check placement ID");
            resolve({ recommendations: {} });
            return;
          }

          resolve({
            recommendations: Object.keys(response.recommendations).map(
              (key) => ({
                ...response.recommendations[key],
              })
            ),
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  });

class NostoRecommendations extends HTMLElement {
  constructor() {
    super();
    this.products = null;
    this.sectionName = this.getAttribute("section-name") || "api-product-card";
    this.sliders = [];
  }

  connectedCallback() {
    this.placementIds = this.dataset.placementIds;
    this.sectionTitle = this.dataset.sectionTitle;
    this.titleEl = this.querySelector("h2");
    this.waitForNostoToLoad();
  }

  async loadRecommendations() {
    if (!window.nostojs) return;
    try {
      const placementIds = this.placementIds
        ? this.placementIds.split(",").map((id) => id.trim())
        : null;
      const res = await getRecommendedProducts(placementIds);

      const container = this.querySelector(".nosto-recommendations");
      if (res) {
        const hasProducts = res.recommendations.some(
          (rec) => rec.products && rec.products.length > 0
        );
        if (hasProducts) {
          this.classList.remove("d-none");
          this.classList.add("d-flex");
        } else {
          this.classList.add("d-none");
          this.classList.remove("d-flex");
          return;
        }
        res.recommendations.forEach((rec) => {
          const realSlotIdRendered = rec.result_id;
          const content = document.createElement("div");
          content.appendChild(
            this.querySelector("template").content.firstElementChild.cloneNode(
              true
            )
          );
          content.querySelector("h2").innerHTML =
            rec.title ?? this.sectionTitle;
          content.setAttribute(
            "id",
            `nosto-recommendations-${realSlotIdRendered}`
          );

          content
            .querySelector(".splide")
            .classList.add(`nosto-slider--${realSlotIdRendered}`);
          container.appendChild(content);

          this.loopProducts(realSlotIdRendered, rec.products);
        });
      }
    } catch (error) {
      console.error("Error loading recommendations:", error);
    }
  }

  loopProducts(realSlotIdRendered, products, count = 0, shown = 0) {
    count = count ? count : products.length - 1;
    let wrapper = this.querySelector(
      `.nosto-slider--${realSlotIdRendered} .splide__list`
    );
    if (shown <= count) {
      fetch(`${products[shown].url}?section_id=${this.sectionName}`).then(
        async (response) => {
          const product = await response.text();
          const fresh = document.createElement("div");
          fresh.innerHTML = product;

          fresh.querySelectorAll("[data-product-link]").forEach((link) => {
            link.setAttribute(
              "href",
              `${link.getAttribute("href")}/?nosto=${realSlotIdRendered}`
            );
          });

          const item = document.createElement("li");
          item.classList.add("splide__slide");
          item.innerHTML = fresh.querySelector("[data-api-content]").innerHTML;

          wrapper.appendChild(item);

          shown++;
          this.loopProducts(realSlotIdRendered, products, count, shown);
        }
      );
    } else {
      this.initCarousel();
    }
  }

  initCarousel() {
    this.querySelectorAll(".js-nosto-recommendations-slider").forEach((el) => {
      let splide = new window.app.Splide(el, {
        gap: 20,
        arrows: true,
        pagination: false,
        padding: 20,
        perPage: 3,
        breakpoints: {
          1024: {
            perPage: 2,
          },
          767: {
            gap: 10,
            perPage: 2,
          },
          480: {
            gap: 10,
            perPage: 1,
          },
        },
      });
      splide.on("mounted", () => {
        document.dispatchEvent(
          new CustomEvent("product-card:load", {
            detail: {
              element: ".js-nosto-recommendations-slider",
            },
          })
        );
      });

      splide.mount();
    });
  }

  waitForNostoToLoad() {
    let limitInterval = 0;
    const checkInterval = setInterval(() => {
      if (typeof window.nostojs === "function") {
        this.loadRecommendations();
        clearInterval(checkInterval);
      } else if (limitInterval >= 10) {
        this.loadRecommendations();
        clearInterval(checkInterval);
      }

      limitInterval++;
    }, 1000);
  }
}

if (!customElements.get("nosto-recommendations")) {
  customElements.define("nosto-recommendations", NostoRecommendations);
}
